let timelineElements = [
  {
    id: 1,
    title: "Loans",
    image: "loanservice",
    description: [
      "Home Loans",
      "Business Loans",
      "Personal Loans",
      "Loan Against Property",
      "Loan Against Security",
    ],
  },
  {
    id: 2,
    title: "Insurance",
    image: "insuranceservice",
    description: ["Vehicle Insurance", "Health Insurance"],
  },
  {
    id: 3,
    title: "Investment Banking",
    image: "investmentservice",
    description: [
      "Investment Banking",
      "Start Ups",
      "Fund Raising",
      "Corporate Advisory",
      "Asset Sale",
      "Brand Acquisition",
      "Project Advisory",
    ],
  },
  {
    id: 4,
    title: "Equity Subscription",
    image: "equityservice",
    description: ["Mutual Funds", "Equity Broking"],
  },
  {
    id: 5,
    title: "Real Estate",
    image: "realestateservice",
    description: [
      "Project Funding",
      "Direct and Client Investments",
      "Agency Business",
      "Special Projects",
    ],
  },
  {
    id: 6,
    title: "Portfolio Management",
    image: "portfolioservice",
    description: ["Portfolio Management"],
  },
  {
    id: 7,
    title: "Wealth Management",
    image: "wealthservice",
    description: [
      "Equity Advisory Services",

      "Portfolio Construction",
      "Research & Industry Analysis",
      "Startup Investments",
      "Real Estate",
      "Debt Investments & Lending",
    ],
  },
];

export default timelineElements;
